import { FC, useEffect, useState } from "react";
import styles from "./AdminPanel.module.scss";
import { Button } from "../ui";
import { Input } from "../ui/Input/Input";
import {
  ILangModel,
  ILangModelCreated,
  ILangModelDeleted,
} from "../../types/lang";
import {
  IAppearance,
  IAppearanceCreated,
  IAppearanceDeleted,
} from "../../types/appearance";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import {
  addLanguage,
  deleteLanguage,
  getDeletedLanguage,
  getLanguages,
  getRestoreLanguage,
} from "../../api/language";
import {
  addAppearance,
  deleteAppearance,
  getAppearance,
  getDeletedAppearance,
  getRestoreAppearance,
} from "../../api/appearance";
import deleteIcon from "../../images/icons/delete.svg";
import returnIcon from "../../images/icons/undo.svg";
import Loader from "../Loader/Loader";

export const AdminParametrs: FC<{ isDelete?: boolean }> = ({ isDelete }) => {
  const [language, setLanguage] = useState("");
  const [appearance, setAppearance] = useState("");
  const [languageData, setLanguageData] = useState<ILangModel[]>([]);
  const [appearanceData, setAppearanceData] = useState<IAppearance[]>([]);
  const [languageDataDelete, setLanguageDataDelete] = useState<ILangModel[]>(
    [],
  );
  const [appearanceDataDelete, setAppearanceDataDelete] = useState<
    IAppearance[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchDataLangDelete() {
    try {
      setIsLoading(true);
      const data: ILangModel[] = await getDeletedLanguage();
      setLanguageDataDelete(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataDelete() {
    try {
      setIsLoading(true);
      const data: IAppearance[] = await getDeletedAppearance();
      setAppearanceDataDelete(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataLang() {
    try {
      setIsLoading(true);
      const data: ILangModel[] = await getLanguages();
      setLanguageData(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchData() {
    try {
      setIsLoading(true);
      const data: IAppearance[] = await getAppearance();
      setAppearanceData(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  async function handleDeletelang(id: number) {
    try {
      setIsLoading(true);
      const ids: ILangModelDeleted = {
        languageId: id,
      };
      await deleteLanguage(ids);
      fetchDataLang();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function handleDeleteAppe(id: number) {
    try {
      setIsLoading(true);
      const ids: IAppearanceDeleted = {
        appearanceId: id,
      };
      await deleteAppearance(ids);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    fetchDataLang();
    fetchDataDelete();
    fetchDataLangDelete();
  }, []);

  async function handlerLanguage() {
    try {
      setIsLoading(true);
      const lang: ILangModelCreated = {
        language: language,
      };
      await addLanguage(lang);
      fetchDataLang();
    } catch {
      return <ErrorPage />;
    } finally {
      setLanguage("");
      setIsLoading(false);
    }
  }
  async function handlerAppearance() {
    try {
      setIsLoading(true);
      const appearan: IAppearanceCreated = {
        appearance: appearance,
      };
      await addAppearance(appearan);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setAppearance("");
      setIsLoading(false);
    }
  }

  async function handleRestoreLang(id: number) {
    try {
      setIsLoading(true);
      const service = {
        languageId: id,
      };
      await getRestoreLanguage(service);
      fetchDataLangDelete();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  async function handleRestoreApper(id: number) {
    try {
      setIsLoading(true);
      const service = {
        appearanceId: id,
      };
      await getRestoreAppearance(service);
      fetchDataDelete();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading)
    return (
      <div className={styles.loader}>
        <Loader color="#ac2386" size={60} borderWidth={5} />
      </div>
    );
  return (
    <div className={styles.container}>
      {isDelete === false && (
        <div className={styles.block}>
          <div className={styles.block_old}>
            <Input
              label={"Servise Sprache"}
              type={"text"}
              id={""}
              placeholder={"Sprache..."}
              value={language}
              setValue={setLanguage}
            />
            <div className={styles.Button}>
              <Button onClick={handlerLanguage}>Add</Button>
            </div>
            <div className={styles.parametr}>
              {languageData &&
                languageData.length > 0 &&
                languageData.map((lang) => (
                  <li className={styles.block_old_item} key={lang.id}>
                    <p className={styles.block_old_description}>
                      {lang.language}
                    </p>
                    <img
                      className={styles.block_old_icon}
                      src={deleteIcon}
                      alt="Icon delete"
                      onClick={() => handleDeletelang(lang.id)}
                    />
                  </li>
                ))}
            </div>
          </div>
          <div className={styles.block_old}>
            <Input
              label={"Servise Aussehen"}
              type={"text"}
              id={""}
              placeholder={"Aussehen..."}
              value={appearance}
              setValue={setAppearance}
            />
            <div className={styles.Button}>
              <Button onClick={handlerAppearance}>Add</Button>
            </div>
            <div className={styles.parametr}>
              {appearanceData &&
                appearanceData.length > 0 &&
                appearanceData.map((apper) => (
                  <li className={styles.block_old_item} key={apper.id}>
                    <p className={styles.block_old_description}>
                      {apper.appearance}
                    </p>
                    <img
                      className={styles.block_old_icon}
                      src={deleteIcon}
                      alt="Icon delete"
                      onClick={() => handleDeleteAppe(apper.id)}
                    />
                  </li>
                ))}
            </div>
          </div>
        </div>
      )}
      {isDelete === true && (
        <div className={styles.block}>
          <div className={styles.block_old}>
            <h5>Gelöschte Sprachen</h5>
            <div className={styles.parametr}>
              {languageDataDelete && languageDataDelete.length > 0 ? (
                languageDataDelete.map((lang) => (
                  <li className={styles.block_old_item} key={lang.id}>
                    <p className={styles.block_old_description}>
                      {lang.language}
                    </p>
                    <img
                      className={styles.block_old_icon}
                      src={returnIcon}
                      alt="Icon delete"
                      onClick={() => handleRestoreLang(lang.id)}
                    />
                  </li>
                ))
              ) : (
                <p>Die Liste ist leer</p>
              )}
            </div>
          </div>
          <div className={styles.block_old}>
            <h5>Gelöschte Aussehen</h5>
            <div className={styles.parametr}>
              {appearanceDataDelete && appearanceDataDelete.length > 0 ? (
                appearanceDataDelete.map((apper) => (
                  <li className={styles.block_old_item} key={apper.id}>
                    <p className={styles.block_old_description}>
                      {apper.appearance}
                    </p>
                    <img
                      className={styles.block_old_icon}
                      src={returnIcon}
                      alt="Icon delete"
                      onClick={() => handleRestoreApper(apper.id)}
                    />
                  </li>
                ))
              ) : (
                <p>Die Liste ist leer</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
